import { EAuthType } from '@onesource/schemas';
import { generateOttMutationFn, isLoggedIn } from '@onesource/services';
import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { Footer } from '#/components/footer';
import { Header } from '#/components/header';

const SignInPage = lazyRouteComponent(() => import('src/pages/sign-in'));

export const Route = createFileRoute('/auth/login')({
  validateSearch: z.object({
    auth_type: z.nativeEnum(EAuthType).optional().catch(undefined),
    return_url: z.string().optional().catch(undefined),
    return_app: z.string().optional().catch(undefined),
    app_name: z.string().optional().catch(undefined),
    tab: z.enum(['magiclink', 'email']).optional().catch(undefined),
  }),
  beforeLoad: async ({ search }) => {
    const { return_url: returnUrl, return_app: returnApp, app_name: appName } = search;

    if (!isLoggedIn()) {
      return;
    }

    if (!returnUrl || !returnApp) {
      throw redirect({ to: '/' });
    }

    if (returnApp.toUpperCase() === 'WORDPRESS') {
      // WordPress redirects are handled by SignInPage via useClassicAreaLink,
      // which shows the "Taking you to the Classic Area" loader.
      return;
    }

    try {
      const decodedReturnUrl = decodeURIComponent(returnUrl);
      const data = await generateOttMutationFn({
        targetApp: returnApp.toUpperCase(),
        redirectUrl: decodedReturnUrl,
      });

      const finalUrl = appName ? `${data.redirectUrl}&appName=${appName}` : data.redirectUrl;
      window.location.href = finalUrl;
    } catch (error) {
      console.error('[SSO Redirect] Failed to generate OTT:', error);
    }
  },
  component: () => (
    <>
      <Header />
      <SignInPage />
      <Footer />
    </>
  ),
});
